"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Histogram", {
  enumerable: true,
  get: function () {
    return _Histogram.Histogram;
  }
});
Object.defineProperty(exports, "HistogramData", {
  enumerable: true,
  get: function () {
    return _Histogram.HistogramData;
  }
});
var _Histogram = require("./Histogram");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfSGlzdG9ncmFtIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hpc3RvZ3JhbS9pbmRleC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgSGlzdG9ncmFtLCBIaXN0b2dyYW1EYXRhIH0gZnJvbSBcIi4vSGlzdG9ncmFtXCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxVQUFBLEdBQUFDLE9BQUEiLCJpZ25vcmVMaXN0IjpbXX0=